module.exports = __webpack_public_path__ + "static/media/icone-split-fatura.866e437c.svg";